module.exports = {"50x50": __webpack_public_path__ + "images/satellite-1-50x50.png"};